import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
import { useMutation } from '@tanstack/vue-query';
import { useVuetify } from '@/plugins/vuetify';
import ReservationService from '@/services/ReservationService';
/**
 * Sends the addons email to the booking's guest now. The server's snackbar says whether it was sent
 * or why not; `sent` is emitted only when it was, so the email timeline can wait for it.
 */
export default /*#__PURE__*/ _defineComponent({
    __name: 'BookingAddonsEmailButton',
    props: {
        bookingId: null,
        disabled: { type: Boolean }
    },
    emits: ["sent"],
    setup(__props, { emit }) {
        const vuetify = useVuetify();
        const isMobile = computed(() => vuetify.breakpoint.smAndDown);
        const { mutate, isPending } = useMutation({
            mutationKey: ReservationService.sendBookingAddonsEmail.mutationKey,
            mutationFn: (input) => ReservationService.sendBookingAddonsEmail.mutationFn(input),
            onSuccess: (result) => {
                if (result?.outcome === 'sent') {
                    emit('sent');
                }
            }
        });
        return { __sfc: true, emit, vuetify, isMobile, mutate, isPending };
    }
});
